import { useQueryClient } from "@tanstack/react-query";
import { Itinerante } from "../../../../services/Itinerante";

export const useItineranteCidadesLista = () => {
  const queryClient = useQueryClient();

  const buscarCidades = (nome?: string) => {
    return queryClient
      .fetchQuery({
        queryKey: ["itinerante-cidades-lista", nome],
        queryFn: () => Itinerante.listar_cidades(nome),
      })
      .then(({ data }) => data);
  };

  return { buscarCidades };
};
